/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from 'react'
import AdorSupportSkeleton from './adorSupportSkeleton'

const AdorSupportPage = () => {
    const [details, setDetails] = useState([])
    const [loading, setLoading] = useState(true)
    const fetchSupportDetails = () => {
        const DISTRIBUTOR = JSON.parse(localStorage.getItem('user')).profile;
        setDetails(DISTRIBUTOR.SUPPORTS)
        setLoading(false)
    }

    useEffect(() => {
        fetchSupportDetails()       
    }, [])
    
    const capitalizeFirstChracter = (string) => {
        let finalString = '';
        string.split('_').forEach((final) => {
            finalString += final.charAt(0).toUpperCase();
        });
        return finalString;
    };

    return (
        <div>
            {loading ? <AdorSupportSkeleton /> : (
                <div className="md:px-[46px] px-4 sm:mt-6 mt-3.5">
                    <h1 className="sm:text-sm50 text-xl font-semibold text-[#000000]">Ador Support</h1>
                    <div className="flex sm:flex-row flex-col -mx-3.5 mt-4">
                        <div className="xl:w-[20%] lg:w-[30%] sm:w-[50%] w-full px-3.5">
                            <div className="w-full">
                                <div className="w-full shadow-s11 border-l-[5px] border-[#ED1C24] py-[39px] px-6 rounded-tr rounded-br">
                                    <span>
                                        <img src="/images/Ador_Welding_logo.svg" alt="icon"/>
                                    </span>
                                </div>
                                <p className="sm:pt-5 pt-3.5 sm:text-lg text-base font-normal text-[#000000]">
                                    Please take a moment to contact us right here if you need assistance. We'll help you resolve your issues immediately!
                                </p>
                            </div>
                        </div>
                        <div className="xl:w-[80%] lg:w-[70%] sm:w-[50%] w-full px-3.5 sm:pt-0 pt-5">
                            <div className="w-full">
                                <div className="flex -mx-2.5 flex-wrap">
                                    {details.map((item, idx) => (
                                        <div key={idx} className="xl:w-1/3 lg:w-1/2 w-full px-2.5 sm:mb-[34px] mb-5">
                                            <div className="h-full w-full border-b border-[#ED1C24] rounded shadow-s12 sm:pt-[16px] pt-3 sm:pb-[26px] pb-5 lg:px-[24px] px-[18px]">
                                                <h5 className="text-f1 font-semibold text-[#000000] w-full capitalize">{['area_sales_engineer'].includes(item?.ROLES) ? capitalizeFirstChracter(item?.ROLES) : capitalizeFirstChracter(item?.ROLES).replace('S', 'B')}</h5>
                                                <div className="flex items-center pt-3">
                                                    <span>
                                                        <img src="/images/usertag.svg" alt="icon"/>
                                                    </span>
                                                    <span className="sm:text-lg text-base font-normal text-[#000000] sm:pl-4 pl-2.5">
                                                        {item?.FIRST_NAME}{' '}{item?.LAST_NAME}
                                                    </span>
                                                </div>
                                                <div className="flex items-center pt-5">
                                                    <span>
                                                        <img src="/images/whatsapp.svg" alt="icon"/>
                                                    </span>
                                                    <a href={`https://wa.me/${item?.PHONE_NUMBER}/`} target='_blank' className="sm:text-lg text-base font-normal text-[#000000] sm:pl-4 pl-2.5" rel="noreferrer">
                                                        {item?.PHONE_NUMBER}
                                                    </a>
                                                </div>
                                                <div className="flex items-center pt-5">
                                                    <span>
                                                        <img src="/images/call.svg" alt="icon"/>
                                                    </span>
                                                    <span className="sm:text-lg text-base font-normal text-[#000000] sm:pl-4 pl-2.5">
                                                        <a href={`tel:${item?.PHONE_NUMBER}`}>
                                                            {item?.PHONE_NUMBER}
                                                        </a>
                                                        
                                                    </span>
                                                </div>
                                                <div className="flex items-center pt-5">
                                                    <span>
                                                        <img src="/images/sms.svg" alt="icon"/>
                                                    </span>
                                                    <a href={`mailto:${item?.EMAIL}`} target='_blank' className="sm:text-lg text-base font-normal text-[#000000] sm:pl-4 pl-2.5" style={{wordBreak: 'break-all'}} rel="noreferrer">
                                                        {item?.EMAIL}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}                       
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            )}
      
        </div>
    )
}

export default AdorSupportPage
